/** True when venue data mentions vegan or plant-based food options. */
export function venueHasVeganFood(venue) {
  if (!venue) return false;
  const name = (venue.name || '').toLowerCase();
  const notes = (venue.notes || '').toLowerCase();
  const backstage = (venue.backstage || '').toLowerCase();
  const affiliate = (venue.affiliate || '').toLowerCase();
  return (
    name.includes('vegan') ||
    name.includes('plant-based') ||
    notes.includes('vegan') ||
    notes.includes('plant-based') ||
    backstage.includes('vegan') ||
    backstage.includes('plant-based') ||
    affiliate.includes('vegan')
  );
}

/** Matches tag-style searches like venues:eco:vegan (spaces around colons allowed). */
export function isVeganTagSearchQuery(query) {
  if (!query || !query.trim()) return false;
  const normalized = query.toLowerCase().replace(/\s/g, '');
  return /^(?:venues:)?(?:eco:)?vegan$/.test(normalized) || normalized === 'vegan';
}
